export default __webpack_public_path__ + "static/portal/img/fig-2.acb69ea.png";